const TriangleExclamation2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 18 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.05575 2.59285C7.92398 1.10447 10.0745 1.10446 10.9428 2.59285L16.2062 11.6159C17.0812 13.1159 15.9992 14.9996 14.2627 14.9996H3.73581C1.99928 14.9996 0.91732 13.1159 1.79231 11.6159L7.05575 2.59285ZM9 5.99963C9.41421 5.99963 9.75 6.33542 9.75 6.74963V8.99963C9.75 9.41385 9.41421 9.74963 9 9.74963C8.58579 9.74963 8.25 9.41385 8.25 8.99963V6.74963C8.25 6.33542 8.58579 5.99963 9 5.99963ZM8.0625 11.2496C8.0625 10.7319 8.48223 10.3121 9 10.3121C9.51777 10.3121 9.9375 10.7319 9.9375 11.2496C9.9375 11.7674 9.51777 12.1871 9 12.1871C8.48223 12.1871 8.0625 11.7674 8.0625 11.2496Z"
      fill="currentColor"
    />
  </svg>
)

export default TriangleExclamation2
